module.exports = __webpack_public_path__ + "img/1.358b11d0.jpg";